/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li4_LabelInputs */

const tr_onbilgi_s10_li4_label = /** @type {(inputs: Onbilgi_S10_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetkilendirme ve İzleme:`)
};

const en_onbilgi_s10_li4_label = /** @type {(inputs: Onbilgi_S10_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorisation and monitoring:`)
};

const de_onbilgi_s10_li4_label = /** @type {(inputs: Onbilgi_S10_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigung und Überwachung:`)
};

const ru_onbilgi_s10_li4_label = /** @type {(inputs: Onbilgi_S10_Li4_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авторизация и мониторинг:`)
};

/**
* | output |
* | --- |
* | "Authorisation and monitoring:" |
*
* @param {Onbilgi_S10_Li4_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li4_label = /** @type {((inputs?: Onbilgi_S10_Li4_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li4_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li4_label(inputs)
	if (locale === "de") return de_onbilgi_s10_li4_label(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li4_label(inputs)
	return tr_onbilgi_s10_li4_label(inputs)
});